import React, { useEffect, useState } from "react";
import { Table, Button, Search, Select, IconDownload } from "@veneer/core";
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';

const CPPComparison = (props) => {
    const [t] = useTranslation();
    const columnsDefaultOrder = [
        'customer',
        'endUserName',
        'countryCode',
        'subRegion',
        'press',
        'program',
        'publicationDate',
        'suppliesSpent',
        'suppliesSpentPreviousMonth',
        'suppliesSpentTwoMonthsPrior',
        'tpIs',
        'tpIsPreviousMonth',
        'tpIsTwoMonthsPrior',
        'bonusPercentage',
        'bonus',
        'compensation',
        'bonusPercentagePreviousMonth',
        'bonusPreviousMonth',
        'compensationPreviousMonth',
        'bonusPercentageTwoMonthPrio',
        'bonusTwoMonthPrior',
        'compensationTwoMonthPrior',
        'cppCurrent',
        'cppPrevPublication',
        'cppTwoMonthsPrior',
        'differencePreviousMonth',
        'differenceTwoMonthsPrior',
        'percentageDifferencePreviousMonth',
        'percentageDifferenceTwoMonthsPrior'
    ];

    const [customerNameFilterVal, setCustomerNameFilterVal] = useState("");
    const [endUserNameFilterVal, setEndUserNameFilterVal] = useState("");
    const [countryCodeNameFilterVal, setCountryCodeNameFilterVal] = useState("");
    const [subRegionNameFilterVal, setSubRegionNameFilterVal] = useState("");
    const [pressNameFilterVal, setPressNameFilterVal] = useState("");
    const [programNameFilterVal, setProgramNameFilterVal] = useState("");
    const [data, setData] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [sortBy, setSortBy] = useState('customer');
    const [sortType, setSortType] = useState('ascending');
    const connectApi = new ConnectAPI();
    const [columnsOrder, setColumnsOrder] = useState(columnsDefaultOrder);
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (page) => setCurrentPage(page);
    const [dateSelected, setDateSelected] = useState();
    const [datesView, setDatesView] = useState([]);
    const [loadingExport, setLoadingExport] = useState(false);
    const pageSize = 50;

    const exportData = () => {
        setLoadingExport(true);
        setTimeout(() => {
            let excelData = data;
            const dataXlsx = excelData;
            const ws = XLSX.utils.json_to_sheet(dataXlsx);
            const wb = XLSX.utils.book_new();
            const date = moment(new Date()).format('YYYYMMDDHHmm');
            const filename = 'CPP Comparison -' + date + '.xlsx';
            const ws_name = 'comparison';
            XLSX.utils.book_append_sheet(wb, ws, ws_name);
            XLSX.writeFile(wb, filename);
            setLoadingExport(false);
        }, 750);
    };

    useEffect(() => {
         //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
        if (ur==window.location.pathname){
            validate=true;
        }
        });
        if (validate==false){
        const { history } = props;
            history.push({
            pathname: '/' 
            });
        }
        //end validate
        const datesLoad = (status, data) => {
          const items = data.map((item) => {
            return {
              value: moment(item.date).format("YYYY-MM-DDTHH:mm:ss"),
              label:
                moment(item.date).format("MMM") +
                " " +
                moment(item.date).format("YYYY"),
            };
          });
          const date = items[0] === undefined ? null : items[0].value;
          setDateSelected(date);
          setDatesView(items);
        };
        connectApi.get("api/Channels/reports/Dates/", 
            "", 
            datesLoad
        ).catch((error) => {
            Swal.fire(
            "Error " + error.response.status,
            error.response.data,
            "error"
            );
        });
      }, []);

      useEffect(() => {
        const fetchData = async () => {
            setLoadingData(true);
            connectApi.get(
                "api/Channels/CPPComparisonReport",
                {
                    params: {
                        date: dateSelected
                    },
                },
                dataResponseLoad
            ).catch((error) => {
                setLoadingData(false);
                Swal.fire(
                    "Error " + error.response.status,
                    error.response.data,
                    "error"
                );
            });
        };
        const dataResponseLoad = (status, data) => {
            data.forEach(x => {
                x.publicationDate = moment(x.publicationDate).format("MMM/YYYY");
                x.bonus = x.bonus.toFixed(2);
                x.compensation = x.compensation.toFixed(2);
                x.bonusPreviousMonth = x.bonusPreviousMonth.toFixed(2);
                x.compensationPreviousMonth = x.compensationPreviousMonth.toFixed(2);
                x.bonusTwoMonthPrior = x.bonusTwoMonthPrior.toFixed(2);
                x.compensationTwoMonthPrior = x.compensationTwoMonthPrior.toFixed(2);
                x.bonusPercentagePreviousMonth = `${(Math.floor(x.bonusPercentagePreviousMonth))} %`;
                x.bonusPercentageTwoMonthPrio = `${(Math.floor(x.bonusPercentageTwoMonthPrio))} %`;
                x.bonusPercentage = `${(Math.floor(x.bonusPercentage))} %`;
                x.percentageDifferencePreviousMonth = `${(Math.floor(x.percentageDifferencePreviousMonth*100))} %`;
                x.percentageDifferenceTwoMonthsPrior = `${(Math.floor(x.percentageDifferenceTwoMonthsPrior*100))} %`;
            });
            setData(data === undefined ? [] : data);
            setLoadingData(false)
        };
        if (dateSelected !== undefined)
            fetchData();
    }, [dateSelected]);

    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if(orderBy==="endUserName"){
            const aSort = a["endUser"] && a["endUser"].toString().toUpperCase();
            const bSort = b["endUser"] && b["endUser"].toString().toUpperCase();
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        }else if (orderBy==="customer" || orderBy==="countryCode"
            || orderBy==="subRegion" || orderBy==="program" ){
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1;
        }else if(orderBy==="publicationDate"){
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        }else{
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        }
        return 0;
    }
    function sort(array, filters, orderBy, orderType) { 
        let arrayFiltered = array;
        // filter
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter =
              typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter) {
              arrayFiltered = arrayFiltered.filter((a) => {
                const aUpper = a[value] && a[value].toString().toUpperCase();
                const filterUpper = filter && filter.toString().toUpperCase();
      
                return aUpper.indexOf(filterUpper) > -1;
              });
            }
          });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy)
            : -descendingComparator(a, b, orderBy);
        
            return value;
        });
    }
    const filteredData = sort(
        data,
        {
            customer: customerNameFilterVal,
            endUser: endUserNameFilterVal,
            countryCode: countryCodeNameFilterVal,
            subRegion: subRegionNameFilterVal,
            press: pressNameFilterVal,
            program: programNameFilterVal
        },
        sortBy,
        sortType
    );
    let pagedData = filteredData.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    ).map( x => {
        if (x.endUser !== "Channel Manual Adjustment") {
            x.endUserName = (
                <a href={"/cpp/report/" + x.idEndUser}>
                    {x.endUser}
                </a>
            );
            return x;
        } else {
            x.endUserName = "Channel Manual Adjustment"
            return x;
        }
    });
    const handleSort = (_, { id, type }) => {
        setSortBy(id);
        setSortType(type);
    };
    const handleChange = (name) => (event) => {
        setDateSelected(event.value);
        setCurrentPage(1);
    };

    return (
        <div>
        <br />
            <div
                style={{
                width: '300px',
                }}
            >
            <Select
                name="datesSearsh"
                onChange={handleChange()}
                options={datesView}
                placeholder= {t('date')}
                value={[dateSelected]}
                clearIcon={false}
            />
            </div>
            <br />
            <div
                style={{
                    backgroundColor: "#f2f2f2",
                    padding: "0.5%",
                    textAlign: "right"
                }} 
            >
                <Table
                    columns={[
                        {
                            id: 'customer',
                            label: t("channels"),
                            filter: (
                                <Search
                                    name="customer-name"
                                    value={customerNameFilterVal}
                                    onChange={(val) => {
                                        setCustomerNameFilterVal(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'endUserName',
                            label: t("endUser"),
                            filter: (
                                <Search
                                    name="endUser-name"
                                    value={endUserNameFilterVal}
                                    onChange={(val) => {
                                        setEndUserNameFilterVal(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'countryCode',
                            label: t('country_Code'),
                            filter: (
                                <Search
                                    name="countryCode-name"
                                    value={countryCodeNameFilterVal}
                                    onChange={(val) => {
                                        setCountryCodeNameFilterVal(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'subRegion',
                            label: t('Subregion'),
                            filter: (
                                <Search
                                    name="subRegion-name"
                                    value={subRegionNameFilterVal}
                                    onChange={(val) => {
                                        setSubRegionNameFilterVal(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'press',
                            label: t('Presses'),
                            filter: (
                                <Search
                                    name="press-name"
                                    value={pressNameFilterVal}
                                    onChange={(val) => {
                                        setPressNameFilterVal(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'program',
                            label: t('CPP Program'),
                            filter: (
                                <Search
                                    name="program-name"
                                    value={programNameFilterVal}
                                    onChange={(val) => {
                                        setProgramNameFilterVal(val);
                                        setCurrentPage(1);
                                    }}
                                />
                            )
                        },
                        {
                            id: 'publicationDate',
                            label: t('publication_Date')
                        },
                        {
                            id: 'suppliesSpent',
                            label: t('supplies_Spent')
                        },
                        {
                            id: 'suppliesSpentPreviousMonth',
                            label: t('supplies_Spent_Previous_Month')
                        },
                        {
                            id: 'suppliesSpentTwoMonthsPrior',
                            label: t('supplies_Spent_Two_Months_Prior')
                        },
                        {
                            id: 'tpIs',
                            label: "TPIs"
                        },
                        {
                            id: 'tpIsPreviousMonth',
                            label: t('tpIs_Previous_Month')
                        },
                        {
                            id: 'tpIsTwoMonthsPrior',
                            label: t('tpIs_Two_Months_Prior')
                        },
                        {
                            id: 'bonusPercentage',
                            label: t('bonusPercentage')
                        },
                        {
                            id: 'bonus',
                            label: t('bonus')
                        },
                        {
                            id: 'compensation',
                            label: t('compensation')
                        },
                        {
                            id: 'bonusPercentagePreviousMonth',
                            label: t('bonus_Percentage_Previous_Month')
                        },
                        {
                            id: 'bonusPreviousMonth',
                            label: t('bonus_Previous_Month')
                        },
                        {
                            id: 'compensationPreviousMonth',
                            label: t('compensation_Previous_Month')
                        },
                        {
                            id: 'bonusPercentageTwoMonthPrio',
                            label: t('bonus_Percentage_Two_Month_Prio')
                        },
                        {
                            id: 'bonusTwoMonthPrior',
                            label: t('bonus_Two_Month_Prior')
                        },
                        {
                            id: 'compensationTwoMonthPrior',
                            label: t('compensation_Two_Month_Prior')
                        },
                        {
                            id: 'cppCurrent',
                            label: t('cpp_Current')
                        },
                        {
                            id: 'cppPrevPublication',
                            label: t('cpp_Prev_Publication')
                        },
                        {
                            id: 'cppTwoMonthsPrior',
                            label: t('cpp_Two_Months_Prior')
                        },
                        {
                            id: 'differencePreviousMonth',
                            label:  t('difference_Previous_Month')
                        },
                        {
                            id: 'differenceTwoMonthsPrior',
                            label: t('difference_Two_Months_Prior')
                        },
                        {
                            id: 'percentageDifferencePreviousMonth',
                            label: t('percentage_Difference_Previous_Month')
                        },
                        {
                            id: 'percentageDifferenceTwoMonthsPrior',
                            label: t('percentage_Difference_Two_Months_Prior')
                        }
                    ]}
                    showFilters
                    columnReorder
                    data={pagedData}
                    showClearAllFilters={true}
                    loading={loadingData}
                    loadingDataLength={50}
                    behavior={{ type: 'singlePage', offset: { top: 0, bottom: 85 } }}
                    onSort={handleSort}
                    onColumnReorder={(newOrder) => setColumnsOrder(newOrder)}
                    preferences={{
                        width: [
                            {
                                columnId: 'customer', width: 250
                            },
                            {
                                columnId: 'endUserName', width: 300
                            },
                            {
                                columnId: 'countryCode', width: 150
                            },
                            {
                                columnId: 'subRegion', width: 150
                            },
                            {
                                columnId: 'press', width: 150
                            },
                            {
                                columnId: 'program', width: 150
                            },
                            {
                                columnId: 'publicationDate', width: 100
                            },
                            {
                                columnId: 'suppliesSpent', width: 120
                            },
                            {
                                columnId: 'suppliesSpentPreviousMonth', width: 120
                            },
                            {
                                columnId: 'suppliesSpentTwoMonthsPrior', width: 120
                            },
                            {
                                columnId: 'tpIs', width: 120
                            },
                            {
                                columnId: 'tpIsPreviousMonth', width: 120
                            },
                            {
                                columnId: 'tpIsTwoMonthsPrior', width: 120
                            },
                            {
                                columnId: 'bonusPercentage', width: 120
                            },
                            {
                                columnId: 'bonus', width: 120
                            },
                            {
                                columnId: 'compensation', width: 120
                            },
                            {
                                columnId: 'bonusPercentagePreviousMonth', width: 120
                            },
                            {
                                columnId: 'bonusPreviousMonth', width: 120
                            },
                            {
                                columnId: 'compensationPreviousMonth', width: 120
                            },
                            {
                                columnId: 'bonusPercentageTwoMonthPrio', width: 120
                            },
                            {
                                columnId: 'bonusTwoMonthPrior', width: 120
                            },
                            {
                                columnId: 'compensationTwoMonthPrior', width: 120
                            },
                            {
                                columnId: 'cppCurrent', width: 120
                            },
                            {
                                columnId: 'cppPrevPublication', width: 120
                            },
                            {
                                columnId: 'cppTwoMonthsPrior', width: 120
                            },
                            {
                                columnId: 'differencePreviousMonth', width: 120
                            },
                            {
                                columnId: 'differenceTwoMonthsPrior', width: 120
                            },
                            {
                                columnId: 'percentageDifferencePreviousMonth', width: 120
                            },
                            {
                                columnId: 'percentageDifferenceTwoMonthsPrior', width: 120
                            }
                        ],
                        sortBy: {
                            id: sortBy,
                            type: sortType
                        },
                        defaultOrder: columnsDefaultOrder,
                        order: columnsOrder
                    }}
                    pagination={{
                        currentPage,
                        onPageChange: handlePageChange,
                        pageSize,
                        totalItems: filteredData.length,
                    }}
                    css={{
                        "tr > td:nth-of-type(1)": {
                            textAlign : 'left'
                        },
                        "tr > td:nth-of-type(2)": {
                          textAlign : 'left'
                        },
                        "tr > td:nth-of-type(3)": {
                            textAlign : 'left'
                        },
                        "tr > td:nth-of-type(4)": {
                          textAlign : 'left'
                        },
                        "tr > td:nth-of-type(5)": {
                          textAlign : 'left'
                        },
                        "tr > td:nth-of-type(6)": {
                            textAlign : 'left'
                        },
                        "tr > td:nth-of-type(7)": {
                          textAlign : 'left'
                        }
                    }}
                ></Table>
            </div>
            <div style={{ textAlign: "left" }}>
                <Button
                    leadingIcon={<IconDownload />}
                    onClick={() => {
                        exportData();
                    }}
                    disabled={data === 0}
                    loading={loadingExport}
                    title={t('download data')}
                >
                    {t('download')}
                </Button>
            </div>
        </div>
    );
}

export default CPPComparison;